import {BaseEvent} from "../BaseEvent";
import {WriteMetricValue} from "../../models/notification/WriteMetricValue";


export class WriteMetricValueNtf extends BaseEvent {
  public static NAME = 'WriteMetricValue';
  public value: WriteMetricValue;

  constructor(value: WriteMetricValue) {
    super(WriteMetricValueNtf.NAME);
    this.value = value;
  }
}
